/*!
 * Product Page: https://www.creative-tim.com/product/now-ui-dashboard-pro-react
 * Copyright 2019 Creative Tim (https://www.creative-tim.com)
 * Coded by Creative Tim
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */
/*eslint-disable*/
import React, { Component } from 'react';
// react component for creating dynamic tables
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, CardTitle, Row, Col, Button } from 'reactstrap';
import ReactTooltip from 'react-tooltip';
import PanelHeader from 'components/PanelHeader/PanelHeader.jsx';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import Loader from 'react-loader-spinner';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import ReactGA from 'react-ga';

const queryString = require('query-string');

var companyId = '';

class GroupList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            loading: true,
            filtered: [],
        };
    }

    //we get the data from the system on this call
    componentDidMount() {
        //are we logged in?
        //yes
        if (
            localStorage.getItem('LOGGEDIN') &&
            localStorage.getItem('LOGGEDIN') === 'true' &&
            localStorage.getItem('DATEEXPIRES') &&
            new Date(localStorage.getItem('DATEEXPIRES')) > new Date()
        ) {
            ReactGA.pageview(window.location.pathname + window.location.search);
            this.loadData();
        }
        //are we logged in?
        //no
        else {
            this.props.history.push('/a/logout');
        }
    }

    loadData() {
        // GET request using fetch with error handling
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                SECRET: localStorage.getItem('SECRET'),
                PASSPHRASE: localStorage.getItem('PASSPHRASE'),
            },
        };

        var qs = queryString.parse(this.props.location.search);

        //start it out as the default
        companyId = localStorage.getItem('companyId');

        //do we have a company id coming in on the querystring?
        //yes
        if (qs['companyId']) {
            //set the one from the querystring
            companyId = qs['companyId'];
        }

        fetch(window.configuration.GroupURL + (companyId !== null ? '?companyId=' + companyId : ''), requestOptions)
            .then(async (response) => {
                //did we get an error?
                //yes
                if (!response.ok) {
                    //did we get an unauthorized?
                    //yes
                    if (response.status === 401) {
                        this.props.history.push('/a/logout');
                    }
                    return null;
                }
                //did we get an error?
                //no
                else {
                    var groups = await response.json();

                    //create our rows
                    var groupObjects = groups.map(function (group) {
                        return {
                            id: group.id,
                            name: group.name,
                            smsPhoneNumber: group.smsPhoneNumber
                                ? '(' +
                                  group.smsPhoneNumber.slice(0, 3) +
                                  ') ' +
                                  group.smsPhoneNumber.slice(3, 6) +
                                  '-' +
                                  group.smsPhoneNumber.slice(6, 10)
                                : '',
                            description: group.description,
                            count: group.members == null ? 0 : parseInt(group.members.filter((g) => g.deleted === false).length).toLocaleString(),
                            open: group.open === true ? 'Open' : 'Closed',
                            actions: (
                                // we've added some custom button actions
                                <div className="actions-right">
                                    <ReactTooltip />
                                    <Link
                                        to={
                                            '/in/f/subscriber?groupId=' +
                                            group.id +
                                            '&redirectAfter=/in/l/groups?id=' +
                                            group.id +
                                            '&companyId=' +
                                            companyId
                                        }
                                    >
                                        <Button
                                            data-tip="add a new subscriber"
                                            className="btn-icon btn-round"
                                            color={'success'}
                                            size="sm"
                                        >
                                            <i className="fa fa-user-plus" />
                                        </Button>
                                    </Link>
                                    {/* spacer between buttons */ ' '}
                                    <Link to={'/in/l/subscribers?id=' + group.id + (companyId !== null ? '&companyId=' + companyId : '')}>
                                        <Button
                                            data-tip="view subscribers"
                                            className="btn-icon btn-round"
                                            color={'success'}
                                            size="sm"
                                        >
                                            <i className="fa fa-users" />
                                        </Button>
                                    </Link>
                                    {/* spacer between buttons */ ' '}
                                    <Link to={'/in/f/group?id=' + group.id + (companyId !== null ? '&companyId=' + companyId : '')}>
                                        <Button
                                            data-tip="edit"
                                            className="btn-icon btn-round"
                                            color={'success'}
                                            size="sm"
                                        >
                                            <i className="fa fa-edit" />
                                        </Button>
                                    </Link>
                                    {/* spacer between buttons */ ' '}
                                    <Button
                                        data-tip="remove"
                                        onClick={() => {
                                            //confirm that they want to remove it
                                            confirmAlert({
                                                closeOnEscape: true,
                                                closeOnClickOutside: true,
                                                onClickOutside: () => {},
                                                onKeypressEscape: () => {},
                                                willUnmount: () => {},
                                                afterClose: () => {},
                                                message:
                                                    'Are you sure you want to remove this group and all ' +
                                                    group.members.length +
                                                    ' of its subscribers?',
                                                buttons: [
                                                    {
                                                        label: 'Yes',
                                                        onClick: () => {
                                                            // DELETE request using fetch with error handling
                                                            const requestOptions = {
                                                                method: 'DELETE',
                                                                headers: {
                                                                    'Content-Type': 'application/json',
                                                                    SECRET: localStorage.getItem('SECRET'),
                                                                    PASSPHRASE: localStorage.getItem('PASSPHRASE'),
                                                                },
                                                            };

                                                            fetch(
                                                                window.configuration.GroupURL +
                                                                    '?id=' + group.id + 
                                                                    (companyId !== null ? '&companyId=' + companyId : ''),
                                                                requestOptions,
                                                            )
                                                                .then(async (response) => {
                                                                    // check for error response
                                                                    //did we get an error?
                                                                    //no
                                                                    if (response.ok) {
                                                                        //refresh the page
                                                                        window.location.reload();
                                                                    }
                                                                })
                                                                .catch((error) => {
                                                                    console.log(error);
                                                                });
                                                        },
                                                    },
                                                    {
                                                        label: 'No',
                                                    },
                                                ],
                                            });
                                        }}
                                        className="btn-icon btn-round"
                                        color={'danger'}
                                        size="sm"
                                    >
                                        <i className="fa fa-times" />
                                    </Button>
                                </div>
                            ),
                        };
                    });

                    //grab our response
                    this.setState({
                        data: groupObjects,
                        loading: false,
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    error: error,
                    loading: false,
                });
                return null;
            });
    }

    onFilteredChangeCustom = (value, accessor) => {
        let filtered = this.state.filtered;
        let insertNewFilter = 1;

        if (filtered.length) {
            filtered.forEach((filter, i) => {
                if (filter['id'] === accessor) {
                    if (value === '' || !value.length) filtered.splice(i, 1);
                    else filter['value'] = value;

                    insertNewFilter = 0;
                }
            });
        }

        if (insertNewFilter) {
            filtered.push({ id: accessor, value: value });
        }

        this.setState({ filtered: filtered });
    };

    render() {
        //are we loading?
        //yes
        if (this.state.loading === true) {
            return (
                <>
                    <Loader
                        height="0"
                        width="0"
                        type="ThreeDots"
                        color="#00BFFF"
                        style={{
                            position: 'fixed',
                            top: '0',
                            left: '0',
                            background: '#99CCFF',
                            opacity: '0.6',
                            zIndex: '998',
                            height: '100%',
                            width: '100%',
                        }}
                    />
                </>
            );
        }
        var qs = queryString.parse(this.props.location.search);

        return (
            <>
                {this.state.loading ? (
                    <Loader
                        height="0"
                        width="0"
                        type="ThreeDots"
                        color="#00BFFF"
                        style={{
                            position: 'fixed',
                            top: '0',
                            left: '0',
                            background: '#99CCFF',
                            opacity: '0.6',
                            zIndex: '998',
                            height: '100%',
                            width: '100%',
                        }}
                    />
                ) : (
                    ''
                )}
                <PanelHeader size="sm"/>
                <div className="content">
                    <Row>
                        <Col xs={12} md={11} style={{ maxWidth: 1500 }}>
                            <Card>
                                <CardHeader>
                                    <CardTitle tag="h4">Groups</CardTitle>
                                    <CardTitle>
                                        Here are the groups that you have been made an admin. &nbsp;
                                        <Link
                                            style={{ color: '#1aafc4' }}
                                            to={
                                                '/in/f/group?add=true' + 
                                                (companyId !== null ? 'companyId=' + companyId : '') +
                                                (qs['returnAfter'] ? '&returnAfter=' + qs['returnAfter'] : '')
                                            }
                                        >
                                            Add a new group
                                        </Link>
                                        <span style={{ display: qs['returnAfter'] ? '' : 'none' }}>
                                            &nbsp;or&nbsp;
                                            <Link
                                                style={{ color: '#1aafc4s' }}
                                                to={qs['returnAfter'] ? qs['returnAfter'] : 'update#replyall'}
                                            >
                                                go back to companies
                                            </Link>
                                        </span>
                                    </CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <ReactTable
                                        data={this.state.data}
                                        filterable={true}
                                        filtered={this.state.filtered}
                                        onFilteredChange={(filtered, column, value) => {
                                            this.onFilteredChangeCustom(value, column.id || column.accessor);
                                        }}
                                        defaultFilterMethod={(filter, row, column) => {
                                            const id = filter.pivotId || filter.id;
                                            if (typeof filter.value === 'object') {
                                                return row[id] !== undefined
                                                    ? filter.value.indexOf(row[id]) > -1
                                                    : true;
                                            } else {
                                                return row[id] !== undefined
                                                    ? String(row[id]).indexOf(filter.value) > -1
                                                    : true;
                                            }
                                        }}
                                        columns={[
                                            {
                                                Header: 'Name',
                                                accessor: 'name',
                                                width: 300,
                                            },
                                            {
                                                Header: 'Phone Number',
                                                accessor: 'smsPhoneNumber',
                                                width: 130,
                                            },
                                            {
                                                Header: 'Subscribers',
                                                accessor: 'count',
                                                width: 100,
                                                Cell: (row) => <div style={{ textAlign: 'center' }}>{row.value}</div>,
                                            },
                                            {
                                                Header: 'Description',
                                                accessor: 'description',
                                                sortable: true,
                                                filterable: true,
                                            },
                                            {
                                                Header: '',
                                                accessor: 'actions',
                                                sortable: false,
                                                filterable: false,
                                                width: 150,
                                            },
                                        ]}
                                        defaultPageSize={this.state.data.length}
                                        showPaginationBottom={false}
                                        className="-striped -highlight"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}

export default GroupList;
